import { forwardRef, useState, useEffect, useContext } from 'react'
import { Input as AnInput, Switch } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { Model } from '@/components'
import * as XLSX from 'xlsx'
import {
  senderTokenConfig,
  senderTokenConfigChange,
  senderToken,
  senderTokenChange
} from '@/store'
import { isAddress, getTokenInfo } from '@/utils'
import Notification from '@/components/Notification'
import { useWeb3React } from '@/hooks/useWeb3React'
import { Cascader, Upload, InputModal, Cover } from '../components'
import { SenderTokenItem } from '../style'
import { TokenType } from '@/store/type'
import { AppContext } from '@/context'
import { Card, CardBody, CardHeader } from './style'
import { Button, Flex } from '@pancakeswap/uikit'
import { FormLabel } from '@/views/MarKetBot/MarketBotLeft/Header/style'
import { Input } from '@/components/Input'
import InfoPopup from '@/components/InfoPopup'
import ToggleSwitch from '@/components/ToggleSwitch'
import { LineFlex } from '@/views/MarKetBot/MarketBotLeft/Content/style'

const { TextArea } = AnInput

function App(props, ref) {
  const { Lang } = useContext(AppContext)
  const { nextStep, isHoldToken, isHoldTokenChange } = props
  const dispatch = useDispatch()

  const config = useSelector(senderTokenConfig)
  const tokenInfo = useSelector(senderToken)

  const { chainId, provider } = useWeb3React()
  const [isCover, setIsCover] = useState(false)

  const [uploadWayTitle, setUploadWayTitle] = useState(``)
  const [uploadWay, setUploadWay] = useState(true)
  const [inputValue, setInputValue] = useState('') // 输入的数据
  const [isShowAutoAmount, setIsShowAutoAmount] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modelKey, setModelKey] = useState('')
  const modelCallBack = () => {
    setIsModalOpen(false)
  }
  const helpClick = (key: string) => {
    setModelKey(key)
    setIsModalOpen(true)
  }

  useEffect(() => {
    setUploadWayTitle(`手动输入`)
    if (uploadWay) {
      setUploadWayTitle(`上传文件`)
    }
  }, [uploadWay])

  useEffect(() => {
    if (config) {
      const tokenInfo = config.join('\n')
      setInputValue(tokenInfo)
    }
  }, [config])


  const uploadWayChange = () => {
    setUploadWay(!uploadWay)
  }

  const inputValueChange = (e) => {
    const value = e.target.value
    setInputValue(value)
  }
  // 上传文件得到数据
  const uploadFileHandler = (infoArr) => {
    const tokenInfo = []
    infoArr.forEach((item) => {
      const str = `${item.Address},${item.Amount}`
      tokenInfo.push(str)
    })
    const inputValue_ = tokenInfo.join('\n')
    setInputValue(inputValue_)
    setUploadWay(true)
  }
  // 查看列子
  const viewCases = () => {
    const arr = [
      '0x13FC5BD0A0ee0E1DD30176b833D436B95c9E2cD2,0.001',
      '0x697FfC45A1bF65ca69601F06743219E86B94B0B1,1',
      '0xAb8dF92b986b91A4964339BD044849DFfEA71AA8,3.45',
    ]
    const inputValue_ = arr.join('\n')
    setInputValue(inputValue_)
  }
  const inputAmount = (e: string) => {
    if (!inputValue) return
    autoAmountHandler(e)
  }
  const closeOverHandler = () => {
    closeOnOverlayClick()
  }

  const autoAmount = () => {
    setIsShowAutoAmount(true)
  }
  const closeOnOverlayClick = () => {
    setIsShowAutoAmount(false)
  }
  // 自动添加数量
  const autoAmountHandler = (num) => {
    const tokenInfo = []
    const token = inputValue.split(/[(\r\n)\r\n]+/)
    token.forEach((item) => {
      const arr = item.split(/[,，]+/)
      if (arr[0]) {
        const obj = { Address: arr[0], Amount: num }
        tokenInfo.push(obj)
      }
    })
    uploadFileHandler(tokenInfo)
  }
  const nextStepHandler = async () => {
    try {
      if (!tokenInfo.address) return Notification.Warning('请填写需要发送的代币地址')
      if (!inputValue) return Notification.Warning('请填写收款地址和数量')
      if (!tokenInfo.decimals) {
        await getTokenInfoHandler(tokenInfo.address)
      }
      const resultArr = inputValue.split(/[(\r\n)\r\n]+/)
      const _config = resultArr.filter((item) => item !== '')
      dispatch(senderTokenConfigChange(_config))

      const configArr = []
      resultArr.forEach((item) => {
        const _arr = item.split(/[,，]+/)
        if (_arr.length !== 2) configArr.push(_arr)
      })
      if (configArr.length > 0) return Notification.Error(`收款地址和数量填写有误`)

      nextStep()
    } catch (error) {
      console.log(error)
    }
  }
  const senderTokenAddressChange = (tokenAddress: string) => {
    const token: TokenType = { address: tokenAddress, symbol: '', decimals: 18 }
    dispatch(senderTokenChange(token))
    if (isAddress(tokenAddress)) {
      getTokenInfoHandler(tokenAddress)
    }
  }
  const getTokenInfoHandler = (address: string) => {
    if (!chainId) return Notification.Error('请链接钱包')
    return new Promise(async (resolve, reject) => {
      try {
        setIsCover(true)
        const { symbol_, decimals_ }: any = await getTokenInfo(address, provider)
        setIsCover(false)
        const _token: TokenType = { address, symbol: symbol_, decimals: decimals_ }
        dispatch(senderTokenChange(_token))
        resolve(true)
      } catch (error) {
        Notification.Error('查找不到该代币信息')
        setIsCover(false)
      }
    })
  }
  const downloadExample = () => {
    // 1. 准备数据
    const data = [
      ['Address', 'Amount'],
      ['0x13FC5BD0A0ee0E1DD30176b833D436B95c9E2cD2', '0.001'],
      ['0x697FfC45A1bF65ca69601F06743219E86B94B0B1', '1'],
      ['0xAb8dF92b986b91A4964339BD044849DFfEA71AA8', '3.45'],
    ]

    // 2. 创建工作簿
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(data)
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    // 3. 生成二进制数据并下载
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'example.xlsx'
    a.click()
    URL.revokeObjectURL(url)
  }
  return (
    <Card>
      <Model callBack={modelCallBack} isModalOpen={isModalOpen} content={Lang[modelKey]} />

      <h1>批量发送代币</h1>
      <CardBody>
        {isShowAutoAmount && <InputModal change={inputAmount} close={closeOverHandler} />}
        <SenderTokenItem className="imagetop2 relative">
          {isCover && <Cover />}
          <div className="item">
            <div className="itemleft">
              <FormLabel>代币地址</FormLabel>
              <Cascader valueChange={senderTokenAddressChange} />
            </div>
            <div className="itemright">
              <FormLabel>小数</FormLabel>
              <Input name='decimals' value={tokenInfo.decimals} disabled />
            </div>
          </div>
          {tokenInfo?.symbol && <FormLabel >描述：{tokenInfo?.symbol} </FormLabel>}
          {tokenInfo?.decimals && <FormLabel > 小数：{tokenInfo?.decimals}</FormLabel>}
        </SenderTokenItem>
        <SenderTokenItem>
          <div className="updateTitle">
            <FormLabel>
              收款地址和数量
            </FormLabel>
            <FormLabel onClick={autoAmount}>
              自动添加数量
            </FormLabel>
            <FormLabel onClick={uploadWayChange}>
              {uploadWayTitle}
            </FormLabel>
          </div>
          {uploadWay ? (
            <TextArea rows={10} onChange={inputValueChange} value={inputValue} />
          ) : (
            <Upload uploadFileHandler={uploadFileHandler} />
          )}
        </SenderTokenItem>

        {uploadWay ? (
          <SenderTokenItem className="flex_sb">
            <FormLabel ref={ref}>每一行应包括地址和数量,逗号分隔</FormLabel>
            <FormLabel className="colorred" onClick={viewCases}>
              查看例子
            </FormLabel>
          </SenderTokenItem>
        ) : (
          <SenderTokenItem className="flex_sb">
            <FormLabel>支持文件类型：Excel</FormLabel>
            {/* <a download href="example.xlsx"> */}
            <FormLabel className="colorred" onClick={downloadExample}>
              下载例子
            </FormLabel>
            {/* </a> */}
          </SenderTokenItem>
        )}
        <LineFlex>
          <Flex>
            <FormLabel>持仓分红代币</FormLabel>
            <InfoPopup
              title="温馨提示"
              content={Lang.lptoken}
            />
          </Flex>
          <ToggleSwitch
            checked={isHoldToken}
            onChange={isHoldTokenChange}/>
        </LineFlex>
        <SenderTokenItem>
          <Button className="magrinl1" onClick={nextStepHandler}>
            下一步
          </Button>
        </SenderTokenItem>
      </CardBody>
    </Card>

  )
}

export default forwardRef(App)
